var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { staticClass: "form form--has-fixed-group", attrs: { novalidate: "" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.success,
              expression: "success",
            },
          ],
          ref: "success",
          staticClass: "alert alert--success",
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.currentUser
                  ? "Your subscriptions have been saved"
                  : "User subscriptions have been updated"
              ) +
              "\n\t"
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("ListSectors", {
            attrs: { counts: false },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function ({ sector }) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.subscribed,
                          expression: "formData.subscribed",
                        },
                      ],
                      staticClass: "toggle",
                      attrs: {
                        id: `follow-${sector.id}`,
                        name: "subscribed",
                        type: "checkbox",
                      },
                      domProps: {
                        value: sector.id,
                        checked: Array.isArray(_vm.formData.subscribed)
                          ? _vm._i(_vm.formData.subscribed, sector.id) > -1
                          : _vm.formData.subscribed,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.formData.subscribed,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = sector.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.formData,
                                  "subscribed",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.formData,
                                  "subscribed",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.formData, "subscribed", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "toggle",
                        attrs: { for: `follow-${sector.id}` },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.formData.subscribed.indexOf(sector.id) > -1
                                ? "Unfollow"
                                : "Follow"
                            ) +
                            "\n\t\t\t\t"
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form__group form__group--submit-fixed" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "wait",
                rawName: "v-wait:disabled",
                value: _vm.waitName,
                expression: "waitName",
                arg: "disabled",
              },
            ],
            staticClass: "btn btn--primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [_vm._v("Save Changes\n\t\t")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }